export default "__VITE_ASSET__CPDSTZtG__"